module.exports = __webpack_public_path__ + "static/media/charan_photo.91caf9a3.png";